export default __webpack_public_path__ + "static/strategic-consulting copy-0be261d710a23ac73c9b483010869f0c.svg";